import { createRouter, createWebHistory, RouterView } from 'vue-router';
import routerKeys from '../store/router-keys';
import { signInWithRedirect, getCurrentUser, signOut } from 'aws-amplify/auth';
// Containers
const Full = () => import('../containers/Full.vue');

/* External Web */
const PreviewSurvey = () => import('@/external-web/views/surveys/Survey.vue');
/* Internal Web */
// Views
const Login = () => import('../views/login/Login.vue');
const Oauth2LoginSuccess = () => import('../views/login/Oauth2LoginSuccess.vue');
const SurveyList = () => import('../views/surveys/SurveyList.vue');
const CreateSurvey = () => import('../views/surveys/CreateSurvey.vue');
const SurveyPublish = () => import('../views/surveys/SurveyPublish.vue');
const QuestionLibrary = () => import('../views/questions/QuestionLibrary.vue');

const router = createRouter({
  history: createWebHistory(),
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ top: 0 }),
  routes: [
    {
      path: '/',
      name: 'Home',
      redirect: routerKeys.surveys.parent,
      meta: { requiresAuth: true },
      component: Full,
      children: [
        {
          path: 'surveys',
          name: 'Survey',
          meta: { requiresAuth: true },
          component: RouterView,
          children: [
            {
              path: '',
              name: 'Library',
              component: SurveyList
            },
            {
              path: routerKeys.surveys.children.new,
              name: 'Create New Survey',
              component: CreateSurvey
            },
            {
              path: routerKeys.surveys.children.publish,
              name: 'Publish',
              component: SurveyPublish
            },
            {
              path: routerKeys.questions.children.edit,
              name: 'Edit Survey',
              component: CreateSurvey
            },
            {
              path: routerKeys.preloadVariable.children.edit,
              name: 'Preloaded Variables',
              component: CreateSurvey
            },
            {
              path: routerKeys.questions.children.list,
              name: 'Question Library',
              component: QuestionLibrary
            }
          ]
        }

      ]
    },
    {
      path: routerKeys.oauth2LoginSuccess,
      name: 'Oauth2LoginSuccess',
      meta: { requiresAuth: false },
      component: Oauth2LoginSuccess
    },
    {
      path: routerKeys.login,
      name: 'Login',
      beforeEnter: async function () {
        try {
          await getCurrentUser(); // this will throw if the user is not authenticated
          await signOut(); // sing the user out if is authenticated
        }
        catch (/** @type {any} */err) {
          // Do nothing if the user is not authenticated
          if (err.name !== 'UserUnAuthenticatedException') {
            console.error(err);
          }
        }
        finally {
          // Sign in the user with OAuth.
          await signInWithRedirect();
        }
      },
      meta: { requiresAuth: false },
      component: Login
    },
    {
      path: routerKeys.preview,
      name: 'PreviewSurvey',
      meta: { requiresAuth: false },
      component: PreviewSurvey
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to && to.hash && to.hash.length > 0) {
    const removedHash = to.hash.replace('#', '');
    next({path: removedHash});
  } else if (to && to.path.indexOf('/app/survey/') >= 0) {
    next();
  } else if (to.matched.some(record => record.meta.requiresAuth)) {
    getCurrentUser().then(() => {
      next();
    }).catch(() => {
      next({path: routerKeys.login, query: { redirect: to.fullPath }});
    });
  } else {
    next();
  }
});

export default router;
